const React = require('react');

const _Image = require('../common/Image.jsx');

function Image(props) {
    const artist = props.itemData || {};
    return <_Image.Component {...props} alt={artist.Name} image={artist.Image} imageUrl={artist.ImageUrl} url={artist.Url} />
}

module.exports = {
    ..._Image,
    Component: Image
};